import axios from "axios";

export function getRecipes() {
  return async function (dispatch) {
   var info = await axios.get("https://the-food-2022.herokuapp.com/allrecipes");
return dispatch({
      type: "GET_RECIPES",
       payload: info.data,
    });
  };
}

export function getOrder(order) {
  return async function (dispatch) {
    var info = await axios.get(`https://the-food-2022.herokuapp.com/order/${order}`);
    return dispatch({
      type: "ORDER",
      payload: info.data,
    });
  };
}

export function getName(name) {
  return async function (dispatch) {
    var info = await axios.get(`https://the-food-2022.herokuapp.com/recipes?name=${name}`);
    return dispatch({
      type: "NAME",
      payload: info.data,
    });
  };
}

export function filterDiets(payload) {
  return ({
    type: "FILTER",
    payload
  });
}

export function detailsForID(id) {
  return async function (dispatch) {
    var info = await axios.get(`https://the-food-2022.herokuapp.com/recipes/${id}`);
    return dispatch({
      type: "DETAILS",
      payload: info.data,
    });
  };
}


export function post(payload) {
  return async function (dispatch) {
    var info = await axios.post('https://the-food-2022.herokuapp.com/recipes',payload);
    console.log(info)
    return info
  };
}

export function diets() {
  return async function (dispatch) {
    var info = await axios.get('https://the-food-2022.herokuapp.com/diets');
    return dispatch({
      type: "DIETS",
      payload: info.data,
    });
  };
}